// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

// Internal Dependencies
import Colours from '../styles/colours';
import MText from './Common/MText';

const MIconButton = ({ text, className, styles, icon, onClick, textColour, disabled }) => (
  <Button
    onClick={onClick}
    style={{
      width:           '250px',
      backgroundColor: Colours.White,
      border:          '1px solid #919191',
      borderRadius:    '30px',
      ...styles,
    }}
    className={`relative p-0 ${className}`}
    disabled={disabled}
  >
    {icon && <div style={{ position: 'absolute', left: '1rem' }}>{icon()}</div>}
    { !_.isEmpty(text) && <MText className="my-2" text={text} colour={textColour} size={12} /> }
  </Button>
);

export default MIconButton;

MIconButton.propTypes = {
  text:       PropTypes.string.isRequired,
  textColour: PropTypes.string,
  className:  PropTypes.string,
  styles:     PropTypes.shape(Object),
  icon:       PropTypes.func,
  onClick:    PropTypes.func,
  disabled:   PropTypes.bool,
};

MIconButton.defaultProps = {
  className:  '',
  styles:     {},
  icon:       () => {},
  onClick:    () => {},
  textColour: Colours.Black,
  disabled:   false,
};
